import { jsx } from "react/jsx-runtime";
import { useTranslations } from "@vocab/react";
import { Box, Tiles } from "braid-design-system";
import { translations } from "../../../../components/.vocab/index.mjs";
import { BrandCard } from "../../BrandCard/BrandCard.mjs";
import { root, noScrollBar } from "./BrandSelectPanel.css.mjs";
const getCommonBrandCardProps = (t) => ({
  showName: false,
  showBrandId: false,
  coverPlaceholderText: t("No cover image")
});
const BrandSelectPanel = ({
  brands,
  setSelectedBrandId,
  onBrandSelected,
  selectedBrandId,
  showCoverImage = true,
  showBrandId = false,
  showName = false,
  tileRowCount = 2
}) => {
  const { t } = useTranslations(translations);
  return /* @__PURE__ */ jsx(Box, { className: [root, brands.length <= 1 && noScrollBar], children: /* @__PURE__ */ jsx(Tiles, { columns: { mobile: 1, tablet: tileRowCount }, space: "small", children: brands.map((brand) => /* @__PURE__ */ jsx(
    BrandCard,
    {
      brand,
      ...getCommonBrandCardProps(t),
      selectable: true,
      onClick: () => {
        if (setSelectedBrandId) {
          setSelectedBrandId(brand.id);
        }
        if (onBrandSelected) {
          onBrandSelected({ data: brand });
        }
      },
      selected: brand.id === selectedBrandId,
      showCoverImage,
      showBrandId,
      showName
    },
    brand.id
  )) }) });
};
export {
  BrandSelectPanel
};
